mutation PurchaseOrderInvoiceScheduleDelete(
  $input: PurchaseOrderInvoiceScheduleDeleteInput!
) {
  purchaseOrderInvoiceScheduleDelete(input: $input) {
    clientMutationId
    deletedEntities {
      rowTimestamp
      id
    }
  }
}
